import { render, staticRenderFns } from "./EnableDisableAdmin.vue?vue&type=template&id=3fb3ff3f&scoped=true"
import script from "./EnableDisableAdmin.vue?vue&type=script&lang=js"
export * from "./EnableDisableAdmin.vue?vue&type=script&lang=js"
import style0 from "./EnableDisableAdmin.vue?vue&type=style&index=0&id=3fb3ff3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb3ff3f",
  null
  
)

export default component.exports